export const SET_IS_FAILED_PAYMENT = "payment/SET_IS_FAILED_PAYMENT";

export const setIsFailedPayment = (isFailedPayment) => {
	return { type: SET_IS_FAILED_PAYMENT, payload: { isFailedPayment } };
};
